<template>
  <span style="color: red">*</span>
</template>

<script setup lang="ts"></script>
